import { TURN_MODE, type TurnMode } from '../config/constants';
import { getSetting, setSetting } from '../settings/userSettings';

export type { TurnMode };

export function loadTurnMode(): TurnMode {
  const v = getSetting('turnMode');
  if (
    v === TURN_MODE.snap15 ||
    v === TURN_MODE.snap30 ||
    v === TURN_MODE.snap45 ||
    v === TURN_MODE.continuous
  ) {
    return v;
  }
  return TURN_MODE.snap30;
}

export function saveTurnMode(mode: TurnMode): void {
  setSetting('turnMode', mode);
}

export function turnModeLabel(mode: TurnMode): string {
  switch (mode) {
    case TURN_MODE.snap15:
      return '15°';
    case TURN_MODE.snap30:
      return '30°';
    case TURN_MODE.snap45:
      return '45°';
    case TURN_MODE.continuous:
      return 'Cont.';
  }
}

/** Returns degrees per snap, or 0 for continuous mode. */
export function snapDegrees(mode: TurnMode): number {
  switch (mode) {
    case TURN_MODE.snap15:
      return 15;
    case TURN_MODE.snap30:
      return 30;
    case TURN_MODE.snap45:
      return 45;
    case TURN_MODE.continuous:
      return 0;
  }
}
